<template>
  <div style="display: contents">
    <button aria-label="Play video" role="button" :title="title" :class="buttonClass" @click="openModal($event);" @keydown.enter="openModal($event);" @hide="closeModal" :id="uuid"><i class="fa fa-play" aria-hidden="true"></i>
      {{ buttonCaption }}
    </button>


    <a11y-dialog :id="`${uuid}_video-modal`" dialog-root="#vue-dialog-root" 
      @dialog-ref="(dialog) => assignDialogRef(uuid, dialog)" 
      :class-names="{ container: 'dialog', overlay: 'fe-modal-overlay' }">
      <div class="dialog-content fe-modal">
        <slot name="closeButtonContent">
          <button type="button" data-a11y-dialog-hide @click="closeModal" @keydown.enter="closeModal"
            aria-label="Close this dialog window" class="fe-modal-close">
            &times;
          </button>
        </slot>
        <div v-if="modalShow">
          <video-modal v-if="videoSrc" :src="videoSrc" :showTitle="showTitle" :title="title"></video-modal>
          <you-tube-modal v-if="youTubeId" :id="youTubeId" :showTitle="showTitle" :title="title" :start="start"
            :lang="lang"></you-tube-modal>
        </div>
      </div>
    </a11y-dialog>
  </div>
</template>

<script>
import VideoModal from "./VideoModal.vue";
import YouTubeModal from "./YouTubeModal.vue";

export default {
  components: { VideoModal, YouTubeModal },
  props: {
    showTitle: {
      default: false,
      type: Boolean,
    },
    youTubeId: null,
    videoSrc: null,

    thumb: null,
    title: null,
    start: "",
    lang: "",
    buttonClass:{
      default:"btn btn-fix",
      type: String
    },
    buttonTitle:""
  },
  useFallback() {
    return true;
  },
  data() {
    return {
      modalShow: false,
      currentComponent: null,
      uuid: "",
      dialog: {},
      name: "",
    };
  },
  computed:{
    buttonCaption(){
      return this.buttonTitle ?? this.title;
    }
  },
  mounted() {
    this.uuid =
      Date.now().toString(36) +
      Math.random()
        .toString(36)
        .substr(2);
  },
  methods: {
    closeModal() {
      this.modalShow = false;
      this.dialog.hide();
    },

    openDialog(event) {
      if (event && !event.code) {
        event.preventDefault();
      }
      if (event.code === "Enter") {
        event.preventDefault();
        this.dialog.show();
      }

      if (!event.code && this.dialog) {
        this.dialog.show();
      }
      console.log(this.dialog);
    },
    assignDialogRef(name, dialog) {
      if (name && dialog) {
        this.dialog = dialog;
        this.name = name;
        this.dialog.on('hide', this.closeModal);
        this.dialog.on('destroy', () => this.dialog.off('hide', this.closeModal));
      }
    },
    openModal(event) {
      this.modalShow = true;
      this.$nextTick(() => {
        this.openDialog(event);
      });
    },
  },
};
</script>
